function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-elecTableau");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-elecTableau"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(3.000000, 3.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})), /*#__PURE__*/React.createElement("path", {
  d: "M27,3 L27,27 L3,27 L3,3 L27,3 Z M16.2999998,7.00000042 C16.0470099,6.88931735 15.7521948,7.00467981 15.6415117,7.25766967 L15.6415117,7.25766967 L12.035492,15.5000004 L15.734,15.8 L13.5422519,22.341478 C13.4316067,22.5944995 13.5469972,22.8893118 13.7999998,23.0000004 C14.0529896,23.1106835 14.3478048,22.995321 14.4584879,22.7423312 L14.4584879,22.7423312 L18.0645076,14.5000004 L14.364,14.2 L16.5576423,7.6584768 L16.5862959,7.57288597 C16.640997,7.34223741 16.5248665,7.09837962 16.2999998,7.00000042 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ElecTableau = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ElecTableau, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-elecTableau.6b090bf4.svg";
export { ForwardRef as ReactComponent };